import React from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import axios from 'axios';

import './theme/assets/plugins/nucleo/css/nucleo.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './theme/assets/scss/argon-dashboard-react.scss';
import './theme/assets/css/argon-overrides.css';

import AdminLayout from './theme/layouts/Admin';
import AuthLayout from './theme/layouts/Auth';
import EmployerLayout from './theme/layouts/Employer';
import history from './helper/history';
import GlobalStore, { Context } from './state/GlobalStore';
import { Auth0Provider } from './providers';
// import { SessionTimeoutManager } from './services/SessionTimeoutManager';

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.headers.common['X-Application-Type'] = 'admin_portal';

const PrivateRoute = ({ user, ...props }) =>
  user ? <Route {...props} /> : <Redirect to="/auth/login" />;

function App() {
  return (
    <div className="App">
      <Auth0Provider>
        <GlobalStore>
          <Router history={history}>
            <Context.Consumer>
              {({ state }) => (
                <Switch>
                  <PrivateRoute
                    user={state.user}
                    path="/admin"
                    render={(props) => <AdminLayout {...props} />}
                  />
                  <PrivateRoute
                    user={state.user}
                    path="/employeradmin"
                    render={(props) => <EmployerLayout {...props} />}
                  />
                  <Route
                    path="/auth"
                    render={(props) => <AuthLayout {...props} />}
                  />
                  <PrivateRoute
                    user={state.user}
                    render={() => <Redirect to="/admin/employers" />}
                  />
                </Switch>
              )}
            </Context.Consumer>
          </Router>
        </GlobalStore>
      </Auth0Provider>
    </div>
  );
}

export default App;
